import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import EcologicalTabs from "@/components/EcologicalTabs";
import ModuleTabs from "@/components/ModuleTabs";
import { UserChangeTabs } from "@/hooks";

import dataJson from "@/../public/data.json";

import "./index.less";
const prefix = "applicationDevelopment";

function ApplicationDevelopment() {
  const { applicationDevelopment } = dataJson;

  const [tabActive, setTabActive] = useState<string | null>("");
  const [key, setKey] = useState<string | null>("");
  const [params, setParams] = useSearchParams();

  const { current, tabsChange } = UserChangeTabs(prefix, applicationDevelopment, key);

  useEffect(() => {
    const key = params.get("key");
    const tabKey = params.get("tabKey");
    key && setKey(key);
    tabKey && setTabActive(tabKey);
  }, []);

console.log('applicationDevelopment.list =>', applicationDevelopment.list)

  return (
    <div className={prefix}>
      <div className={`${prefix}-banner`} style={{ backgroundImage: `url(${applicationDevelopment.banner_bg_img})` }}>
        <div className={`${prefix}-title`}>{applicationDevelopment.title}</div>
        <div className={`${prefix}-describe`}>
          <div>{applicationDevelopment.describe}</div>
        </div>
      </div>
      <EcologicalTabs current={current} list={applicationDevelopment.list} onChange={tabsChange} />
      <div className={`${prefix}-content`}>
        {applicationDevelopment.list.map((item: any) => {
          return (
            <div key={item.key} className={`${prefix}-module`} id={`${prefix}-module-${item.key}`}>
              <div className={`${prefix}-module-title`}>{item.title}</div>
              <div className={`${prefix}-module-tabs`}>
                <ModuleTabs list={item.list} tabActive={tabActive} isShowImg= { item.key === '1'} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ApplicationDevelopment;
